export function SparklineChart({
  values,
  grain,
}: {
  values: number[];
  grain: "week" | "month";
}) {
  if (!values.some((value) => value > 0)) return null;

  const max = Math.max(...values, 1);
  const width = 640;
  const height = 56;
  const points = values.map((value, index) => {
    const x = (index / Math.max(values.length - 1, 1)) * width;
    const y = height - 6 - (value / max) * (height - 14);
    return `${x.toFixed(1)},${y.toFixed(1)}`;
  });
  const d = points
    .map((point, index) => `${index === 0 ? "M" : "L"}${point}`)
    .join(" ");
  const axis = grain === "week" ? "últimas 12 semanas" : "últimos 12 meses";

  return (
    <div className="mt-5 border-t border-border pt-4">
      <p className="mb-2 text-xs text-muted-foreground">
        Citas completadas · {axis}
      </p>
      <svg
        className="h-14 w-full"
        viewBox={`0 0 ${width} ${height}`}
        preserveAspectRatio="none"
        aria-hidden="true"
      >
        <path
          d={`${d} L${width},${height} L0,${height} Z`}
          className="fill-foreground/10"
        />
        <path
          d={d}
          fill="none"
          className="stroke-foreground"
          strokeWidth="2"
          vectorEffect="non-scaling-stroke"
        />
      </svg>
    </div>
  );
}

export function Cadence({ gaps }: { gaps: number[] }) {
  if (gaps.length === 0) return null;

  return (
    <div className="mt-3 flex items-center" aria-label="Tiempo entre visitas">
      <span className="h-2 w-2 rounded-full bg-foreground" />
      {gaps.map((gap, index) => (
        <span key={`${gap}-${index}`} className="relative flex flex-1 items-center">
          <span className="h-px w-full bg-border" />
          <em className="absolute left-1/2 top-1 -translate-x-1/2 text-[11px] not-italic text-muted-foreground">
            {gap}d
          </em>
        </span>
      ))}
      <span className="h-2 w-2 rounded-full bg-foreground" />
    </div>
  );
}
